import { DeploySystemDetail } from '@/app/interfaces/deploy-system-of-ai-detail';
import { SystemDeployReviewFieldKey } from '@/app/interfaces/system-deploy-review-fields.types';
import { SystemDeployReviewFieldsService } from '@/app/services/ia-services/system-deploy-review-fields.service';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-deploy-iso-compliance',
  standalone: true,
  imports: [CommonModule, TooltipComponent],
  templateUrl: './iso-compliance.component.html',
})
export class SystemDeployIsoComplianceComponent {
  @Input() isoData: DeploySystemDetail | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: SystemDeployReviewFieldsService) {}

  previousReviewText(fieldKey: SystemDeployReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }
}
